/** Allowed payment-proof formats app-wide: JPG/JPEG, PNG, PDF only. */

export const PAYMENT_PROOF_ACCEPT =
  'image/jpeg,image/png,application/pdf,.jpg,.jpeg,.png,.pdf';

export const PAYMENT_PROOF_HINT = 'JPG, JPEG, PNG, or PDF';

export const PAYMENT_PROOF_REJECT_MESSAGE =
  'Only JPG, JPEG, PNG, or PDF payment proof is allowed.';

const ALLOWED_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
]);

const ALLOWED_EXT = /\.(jpe?g|png|pdf)$/i;

export function isAllowedPaymentProofFile(file) {
  if (!file) return false;
  const type = String(file.type || '').toLowerCase();
  if (type && ALLOWED_TYPES.has(type)) return true;
  return ALLOWED_EXT.test(file.name || '');
}

export function isPaymentProofImage(file) {
  if (!file) return false;
  const type = String(file.type || '').toLowerCase();
  if (type === 'image/jpeg' || type === 'image/jpg' || type === 'image/png') {
    return true;
  }
  return /\.(jpe?g|png)$/i.test(file.name || '');
}
